<template>
  <div class="expiredEvent">
    <Breadcrumbs>
      <span
        ><router-link :to="{ name: 'tickets' }">{{ $t('TICKETS_PAGE_TITLE') }}</router-link></span
      >
    </Breadcrumbs>
    <div class="pageContainer">
      <div class="main">
        <div class="message">{{ $t('TICKETS_EXPIRED') }}</div>
        <div class="nav">
          <router-link
            :to="{ name: 'home' }"
            v-if="!homeView === 'ticket'"
            class="goHome btn btn-primary"
            >{{ $t('GO_HOME') }}</router-link
          >
          <router-link :to="{ name: 'tickets' }" class="goHome btn btn-primary">{{
            $t('TICKETS_PAGE_TITLE')
          }}</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Breadcrumbs from '../Breadcrumbs.vue';

export default {
  name: 'ExpiredEvent',
  components: { Breadcrumbs },
  computed: {
    ...mapState({
      homeView: (state) => state.app.homeView,
    }),
  },
  methods: {},
  mounted() {},
};
</script>

<style lang="scss" scoped>
@import '../../scss/grid';

.pageContainer {
  @extend .row;
}

.main {
  @extend .col-md-8;
  float: none;
  margin-left: auto;
  margin-right: auto;
  background: white;
  box-shadow: 0 2px 4px 0 #aaadac;
  margin-top: $sp * 5;
  margin-bottom: $sp * 3;
  padding: 0 $sp * 2 $sp * 2 $sp * 2;
  text-align: center;
  @media screen and (max-width: $screen-sm) {
    padding-left: $sp;
    padding-right: $sp;
  }
  .message {
    padding-top: $sp * 2;
    line-height: 2;
  }
}
.actions {
  margin-top: 3 * $sp;
  text-align: center;
  a {
    margin-bottom: $sp;
  }
}
.nav {
  margin-top: 2 * $sp;
}
</style>
